import React from 'react';
import PropTypes from 'prop-types';
import { CaptionText as Caption } from '@paypalcorp/pp-react';
import { FormattedMessage } from 'react-intl';

export const CaptionText = ({ className, text }) => (
    <Caption className={className} >
        <FormattedMessage id={text} />
    </Caption>
);

CaptionText.propTypes = {
    className: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired
};